import { Plus, Edit } from "lucide-react";
import { ChangeType } from "../DesignUploadStep.types";

interface ChangeIconProps {
  changeType: ChangeType;
}

export const ChangeIcon = ({ changeType }: ChangeIconProps) => {
  if (
    changeType === ChangeType.STRUCTURE_ADDED ||
    changeType === ChangeType.PORT_COMBO_ADDED ||
    changeType === ChangeType.GRATING_ADDED ||
    changeType === ChangeType.PAD_ADDED
  ) {
    return <Plus className="h-4 w-4 text-green-600" />;
  }
  return <Edit className="h-4 w-4 text-blue-600" />;
};
